<template>
  <div>
    <v-dialog v-model="exclude_report" persistent  max-width="612" content-class="elevation-0">
       <v-card
        class="mx-auto align-self-stretch mb-5 mr-5"
        tile
        :loading="edit_form_loading"
        max-width="600"
      >
      <v-card elevation="0">
        <v-card-title>Excluded Project</v-card-title>
        <v-col class="pt-0">
          <v-data-table
            :headers="headers"
            class="elevation-1 rounded-0 my-transaction-table"
            item-key="project_id"
            :items="items.projects"
            dense
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  {{ item.p_name }}
                </td>
                <td>
                  {{ (item.customer)?item.customer.full_name:'' }}
                </td>
                <td>
                  {{ item.p_code }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-card>
      <v-card elevation="0">
        <v-card-title>Excluded chart of account</v-card-title>
        <v-col class="pt-0">
          <v-data-table
            :headers="headers1"
            class="elevation-1 rounded-0 my-transaction-table"
            item-key="project_id"
            :items="items.banks"
            dense
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  {{ item.bank_name }}
                </td>
                <td>
                  {{ item.bank_code }}
                </td>
                <td>
                  {{ (item.acctype)?item.acctype.acc_type:'' }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-col>
      </v-card>

        <v-card-actions class="pa-0" >
          <v-btn
            fab
            color="error"
            x-small
            absolute
            @click="closePopup()"
            class="custom-close-btn"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
       </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
export default {
  data() {
    return {
      loading: false,
      edit_form_loading:false,
      items: {
        projects: [],
        banks: [],
      },
      headers: [
        { value: "p_name", text: "Project Name", sortable: false },
        { value: "customer.full_name", text: "Customer Name", sortable: false  },
        { value: "p_code", text: "Code", sortable: false},
      ],
      headers1: [
        { value: "bank_name", text: "Bank Name", sortable: false},
        { value: "bank_code", text: "Short Code", sortable: false },
        { value: "acc_type", text: "Type", sortable: false},
      ],
    };
  },
  props: ["exclude_report"],
  watch: {},
  computed: {},
  components: {},
  methods: {
    closePopup() {
      this.$emit('close_popup')
    },
    getExcludedProjectList() {
      let _self = this;
      this.loading = true;
      axios
        .get("excluded_list?itemsPerPage=-1")
        .then((response) => {
          _self.items.projects = response.data.data.projects;
          _self.items.banks = response.data.data.banks;
          console.log("_self.items.banks", _self.items.banks);
          _self.loading = false;
        })
        .catch(function () {
          _self.loading = false;
        });
    },
  },
  mounted() {
    this.getExcludedProjectList();
  },
};
</script>